var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.aec2c4c1114a1775997ffe572898abfe.svg#M';
                    var viewUrl = 'sprites.aec2c4c1114a1775997ffe572898abfe.svg#view-M';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };